import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import axios from 'axios';
import { QueryRouter, LoggingHelper, LaunchDarklyProvider } from 'sarsaparilla';

import store from './store';
import App from './App';

import './index.scss';

axios.defaults.headers.common.Pragma = 'no-cache';

render(
  <Provider store={store}>
    <QueryRouter shouldRestoreScroll>
      <LaunchDarklyProvider>
        <App />
      </LaunchDarklyProvider>
    </QueryRouter>
  </Provider>,
  document.getElementById('recApp')
);

if (process.env.NODE_ENV !== 'development') {
  // intercept and log all uncaught system errors
  const onError = (msg, url, line, col, error) => {
    let extra = !col ? '' : `\ncolumn: ${col}`;
    extra += !error ? '' : `\nerror: ${error}`;
    const message = `Error: ${msg}\nurl: ${url}\nline: ${line}${extra}`;
    LoggingHelper.logError(message);
    return true;
  };

  window.onerror = onError;
}
